import { controls } from "../../controls";

const tr304 = {
  label: "Divident Transfer to Reserve Fund",
  pageLabel: "Divident Transfer to Reserve Fund",
  starting: true,
  url: "tr304",
  pageType: "history",
  formState: { checked: "view" },
  formActions: { edit: { allow: true }, delete: { allow: true } },
  // "Address.",
  form: [

    ...controls.displayText({ label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ defaultValue: "assigned_branch", isReadOnly: true, isRequired: true, star: true }),
    ...controls.showData({ data: "branch_display", name: "branch_display", width: "col-sm-4" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-4 " }),

    ...controls.displayText({ label: "Member Type", star: true, width: "col-sm-2" }),
    ...controls.select({
      name: "member_type", isRequired: true, width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "Regular",
        value: "regular"
      },
      {
        label: "Associated",
        value: "associated"
      },
      {
        label: "Nominal (B-Class)",
        value: "nominal"
      }]
    }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-8 " }),

    ...controls.displayText({ label: "Member Number From-To", width: "col-sm-2" }),
    ...controls.numberOnly({ name: "member_number_from", width: "col-sm-1" }),

    ...controls.displayText({ label: "-", width: "col-sm-0" }),
    ...controls.numberOnly({ name: "member_number_to", width: "col-sm-1" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-8 " }),

    ...controls.magicDateLabel({ label: "Up to Date", star: true, width: "col-sm-2" }),
    ...controls.magicDate({ isReadOnly: false, isRequired: true, name: "up_to_date", default: "sessiondate", width: "col-sm-2", dateType: "ontype", }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-8 " }),

    ...controls.magicDateLabel({ label: "Post Date", star: true, width: "col-sm-2" }),
    ...controls.magicDate({ isReadOnly: true, isRequired: true, name: "post_date", default: "sessiondate", width: "col-sm-2", dateType: "ontype", }),

    ...controls.radio({
      name: "", width: "col-sm-6", options: [
        { label: "Trial", value: "T" },
        { label: "Post", value: "P" },
      ]
    }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

    ...controls.displayText({ label: "Divident Paid GL", star: true, width: "col-sm-2" }),
    ...controls.GL({ tab: "Modal" }),
    ...controls.showData({ data: "gl_display", isRequired: true, name: "gl_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6 " }),

    ...controls.displayText({ label: "Reserve Fund GL", star: true, width: "col-sm-2" }),
    ...controls.GL({ tab: "Modal" }),
    ...controls.showData({ data: "gl_display", isRequired: true, name: "gl_display", width: "col-sm-2" }),


  ],

  history: {
    perPage: 10,
    reportHeader: "Divident Transfer to Reserve Fund",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      {
        Header: "Sr",
        type: "autoinc",
        accessor: "srno",
        width: 30
      },
      {
        Header: "Member No.",
        accessor: "member_number"
      },
      {
        Header: "CIN",
        accessor: "cin",
      },
      {
        Header: "Name",
        accessor: "name",
        width: 350
      },
      {
        Header: "Balance",
        accessor: "balance",
        type: "currency"
      },

      {
        Header: "Dividend",
        accessor: "dividend",
        type: "currency"
      },

      {
        Header: "Trf to AcctCode",
        accessor: "trf_acctcode"
      },
    ]
  }
};

export default tr304;